import { Component, computed, effect, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { OneSignal } from 'onesignal-ngx';
import { UserDataService } from '../../../services/user-data.service';
import { NotificationsService } from '../../../services/notifications.service';
import { NotificationDataService } from '../../../services/notifications.data.service';
import { Notifications } from '../../../models/notification';

@Component({
  selector: 'notifications-nav',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './notifications-nav.component.html',
  styles: ``
})
export class NotificationsNavComponent {
  private oneSignal = inject(OneSignal);
  private notificationService = inject(NotificationsService)  
  private router = inject(Router)
  private userDataService = inject(UserDataService);
  public notificationDataService = inject(NotificationDataService)

  public showAlert = computed(() => this.notificationDataService.notifications().length > 0);
  public alertsCount = computed(() => this.notificationDataService.notifications().length);  

  constructor(){
    effect(() => {
      const data = this.userDataService.userData();               
      
      if(!data){
        return;
      }

      this.setOneSignal();
    });
  }


   ngOnInit(){                        
    this.notificationService.getNotifications().subscribe({
      next: (response) => {
        this.notificationDataService.setNotifications(response);
      }
    })  
  }

  isUserLoggedIn(): boolean {
    return !!this.oneSignal.User.externalId;
  }

  async setOneSignal(){
    if(this.isUserLoggedIn()){
      return;
    }                   

    await this.oneSignal.login(this.userDataService.userData()?.userId!);    

    this.oneSignal.Notifications.addEventListener('foregroundWillDisplay', (event) => {    
      
      const notification: Notifications = {
        notificationId: event.notification.notificationId,
        title: event.notification.title!,
        message: event.notification.body,
        redirectScreen: (event.notification.additionalData as any)?.screen || '' ,
        creationDate: new Date(),
      };

      this.notificationDataService.addNotification(notification);
    });     
  }

  read(notification: Notifications){    
    if(!notification){
      return;
    }

    this.notificationService.markAsRead(notification.notificationId).subscribe({      
      next: () =>{
          this.notificationDataService.removeNotification(notification);                    
          this.router.navigate([notification.redirectScreen]);
      }
    })

  }

}
